import React from "react";
import styled from "styled-components";
import { FaInstagram, FaLinkedin, FaFacebook, FaWhatsapp } from "react-icons/fa";
import { AiOutlineCopyright } from "react-icons/ai";

const Wrapper = styled.div`
  width: 100%;
`;

const FooterMain = styled.div`
  background: #0f172a;
  color: #fff;
  padding: 60px 80px;

  @media (max-width: 1024px) {
    padding: 50px 40px;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  font-size: 1.4rem;
  margin-bottom: 15px;
  color: #facc15;

  @media (max-width: 600px) {
    font-size: 1.2rem;
  }
`;

const Text = styled.p`
  font-size: 0.95rem;
  line-height: 1.7;
  color: #d1d5db;

  @media (max-width: 600px) {
    font-size: 0.9rem;
  }
`;

const Link = styled.p`
  margin: 6px 0;
  cursor: pointer;
  transition: 0.3s;
  font-size: 0.95rem;

  &:hover {
    color: #facc15;
    padding-left: 5px;
  }

  @media (max-width: 600px) {
    font-size: 0.9rem;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 15px;

  @media (max-width: 600px) {
    justify-content: center;
  }
`;

const IconLink = styled.a`
  font-size: 1.6rem;
  color: white;
  transition: 0.3s;

  &:hover {
    color: #facc15;
    transform: scale(1.2);
  }
`;

const BottomBar = styled.div`
  background: #020617;
  color: #ccc;
  text-align: center;
  padding: 15px;
  font-size: 0.9rem;

  @media (max-width: 600px) {
    font-size: 0.8rem;
    padding: 12px;
  }
`;

const Footer = () => {
  return (
    <Wrapper>
      <FooterMain>
        <Grid>

          {/* Column 1 */}
          <Column>
            <Title>The ZoFinds</Title>
            <Text>
              We offer Amazon’s best and hottest deals. Easily find what you need with top quality recommendations.
            </Text>
          </Column>

          {/* Column 2 */}
          <Column>
            <Title>Quick Links</Title>
            <Link>Home</Link>
            <Link>About Us</Link>
            <Link>Services</Link>
            <Link>Blog</Link>
            <Link>Contact Us</Link>
          </Column>

          {/* Column 3 */}
          <Column>
            <Title>Amazon Disclosure</Title>
            <Text>
              The ZoFinds participates in the Amazon Associates Program and earns commissions from qualifying purchases.
            </Text>

            <SocialIcons>
              <IconLink href="https://www.instagram.com/husstalyah?igsh=MTN5bGRkaWE4emg1MQ==" target="_blank">
                <FaInstagram />
              </IconLink>

              <IconLink href="https://wa.me/qr/C2WQJLMFY4QNE1" target="_blank">
                <FaWhatsapp />
              </IconLink>

              <IconLink href="https://linkedin.com" target="_blank">
                <FaLinkedin />
              </IconLink>

              <IconLink href="https://www.facebook.com/share/18TkcmFLnV/" target="_blank">
                <FaFacebook />
              </IconLink>
            </SocialIcons>
          </Column>

        </Grid>
      </FooterMain>

      <BottomBar>
        Copyright <AiOutlineCopyright /> 2022 — Developed by{" "}
        <strong>atube291@gmail.com</strong>. All Rights Reserved.
      </BottomBar>
    </Wrapper>
  );
};

export default Footer;